export default "__VITE_ASSET__D$dkvo5C__"